import BaseEnumType from "../../common/base-enum-type";

const IncompleteType = Object.freeze({
    DQ: new BaseEnumType("1", "DQ"),
    DNF: new BaseEnumType("2", "DNF"),
    Forfeit: new BaseEnumType("3", "Forfeit"),
    Retired: new BaseEnumType("4", "Retired"),
    NotPlayed: new BaseEnumType("5", "NP")
});

export default IncompleteType;
